import { render } from "./IdentityManagementForMyApp.vue?vue&type=template&id=0b81168b&scoped=true"
import script from "./IdentityManagementForMyApp.vue?vue&type=script&lang=js"
export * from "./IdentityManagementForMyApp.vue?vue&type=script&lang=js"

import "./IdentityManagementForMyApp.vue?vue&type=style&index=0&id=0b81168b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b81168b"]])

export default __exports__